
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(3563|4658|8307|87)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
